import { ApartmentOutlined } from "@mui/icons-material";
import { Box } from "@mui/material";

interface IKeydriveOrganizationAvatar {
    size: "small" | "medium" | "large";
}

export const KeydriveOrganizationAvatar = ({ size }: IKeydriveOrganizationAvatar) => {
    let width = "36px";
    let height = "36px";

    if (size === "medium") {
        width = "56px";
        height = "56px";
    } else if (size === "large") {
        width = "64px";
        height = "64px";
    }

    return (
        <Box
            width={width}
            height={height}
            sx={{
                backgroundColor: "#E9EFF4"
            }}
            borderRadius="4px"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <ApartmentOutlined 
                sx={{
                    color: "#22638D",
                }}
            />
        </Box>
    );
}